export const CONTACT_INFO = Object.freeze({
  phone: Object.freeze({
    display: "01644403534",
    tel: "01644403534",
    whatsapp: "8801644403534",
  }),
  helpline: Object.freeze({
    display: "01342824843",
    tel: "01342824843",
  }),
  social: Object.freeze({
    facebookUrl: "https://www.facebook.com/shareemusium",
  }),
  whatsappMessage: "Hi Nabil Fashion, I need help with my order.",
});

export const getTelHref = (number) => `tel:${number}`;

export const getWhatsAppHref = (number, message) => {
  const baseUrl = `https://wa.me/${number}`;

  if (!message) {
    return baseUrl;
  }

  return `${baseUrl}?text=${encodeURIComponent(message)}`;
};

export const toBanglaDigits = (value) =>
  String(value).replace(/\d/g, (digit) => "০১২৩৪৫৬৭৮৯"[Number(digit)]);
